const generateFiles = (count) =>
  Array.from({ length: count }, (_, i) => `${i + 1}.webp`)

const portfolioFolderMap = [
  {
    category: 'Other work',
    folder: '', // root: /public/images/portfolio/
    files: generateFiles(32),
  },
  {
    category: 'Traditional',
    folder: 'traditional',
    files: generateFiles(6),
  },
  {
    category: 'Pop-culture',
    folder: 'popculturecartoon',
    files: generateFiles(45),
  },
  {
    category: 'Fineline',
    folder: 'fineline',
    files: generateFiles(41),
  },
  {
    category: 'Black and grey',
    folder: 'blackandgrey',
    files: generateFiles(8),
  },
]

export const portfolioItems = portfolioFolderMap.flatMap(({ category, folder, files }) =>
  files.map((fileName, index) => ({
    id: `${folder || 'root'}-${index + 1}`,
    title: `${category} ${index + 1}`,
    category,
    image: folder
      ? `/images/portfolio/${folder}/${fileName}`
      : `/images/portfolio/${fileName}`,
    alt: `${category} tattoo ${index + 1}`,
    width: 1200,
    height: 1200,
  }))
)

export const portfolioCategories = [
  'All',
  'Other work',
  'Traditional',
  'Pop-culture',
  'Fineline',
  'Black and grey',
]